import styled from "styled-components";

export const TopHeaderContainer = styled.div`
  && {
    position: fixed;
    top: 0;
    width: 100%;
    z-index: 1000;

    .ant-col {
      display: flex;
      align-items: center;

      span {
        margin: 0;
      }
    }

    img[alt="Logo"] {
      margin: 0 8px 8px 0;
      height: 28px;
    }
  }
`;
